(() => {
  const root = document.getElementById("closeup-verification-root");
  if (!root) return;
  if (!document.getElementById("closeup-atc-centering")) {
    const centering = document.createElement("style");
    centering.id = "closeup-atc-centering";
    centering.textContent = ".productitem [data-closeup-approved=\"true\"]{display:flex;align-items:center;justify-content:center}.productitem [data-closeup-approved=\"true\"] .atc-button--text{line-height:normal}";
    document.head.append(centering);
  }

  const settings = root.dataset;
  const originalControls = new WeakMap();
  let statusPromise;
  let orderProperties = {};
  const seededApproved = settings.initialApproved === "true";
  let seededOrderProperties = {};
  try { seededOrderProperties = seededApproved && settings.orderProperties ? JSON.parse(settings.orderProperties) : {}; } catch { seededOrderProperties = {}; }

  const NATIVE_ICON_HTML = '<span class="atc-button--icon"><svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 50 50" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-dasharray="90 150"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"></animateTransform></circle></svg></span>';

  const controls = () =>
    Array.from(
      document.querySelectorAll(
        '[data-closeup-pending], [data-closeup-verification-bound]',
      ),
    ).filter((control) => !control.closest(".closeup-verification-page"));

  function remember(control) {
    if (originalControls.has(control)) return;
    originalControls.set(control, {
      html: control.innerHTML,
      href: control.getAttribute("href"),
      ariaLabel: control.getAttribute("aria-label"),
      role: control.getAttribute("role"),
      tabIndex: control.getAttribute("tabindex"),
    });
  }

  function reveal(control) {
    control.style.removeProperty("visibility");
    delete control.dataset.closeupPending;
  }

  function conceal(control) {
    control.style.setProperty("visibility", "hidden");
  }

  function approve(control) {
    remember(control);
    if (control.dataset.closeupApproved === "true") return;
    const label = control.querySelector(".atc-button--text");
    if (label) {
      label.textContent = settings.addLabel || "Add to cart";
    } else {
      control.innerHTML = `<span class="atc-button--text">${settings.addLabel || "Add to cart"}</span>`;
    }
    if (!control.querySelector(".atc-button--icon")) {
      control.insertAdjacentHTML("beforeend", NATIVE_ICON_HTML);
    }
    control.removeAttribute("href");
    control.setAttribute("role", "button");
    control.setAttribute("tabindex", "0");
    control.setAttribute("aria-label", settings.addLabel || "Add to cart");
    control.dataset.closeupApproved = "true";
  }

  function requireApproval(control) {
    const original = originalControls.get(control);
    if (!original || control.dataset.closeupApproved !== "true") return;
    control.innerHTML = original.html;
    if (original.href) control.setAttribute("href", original.href);
    else control.setAttribute("href", settings.verificationUrl);
    if (original.ariaLabel) control.setAttribute("aria-label", original.ariaLabel);
    else control.removeAttribute("aria-label");
    if (original.role) control.setAttribute("role", original.role);
    else control.removeAttribute("role");
    if (original.tabIndex !== null) control.setAttribute("tabindex", original.tabIndex);
    else control.removeAttribute("tabindex");
    control.classList.remove("processing");
    control.removeAttribute("aria-busy");
    delete control.dataset.closeupApproved;
  }

  function applyStatus(status) {
    orderProperties = status.approved && status.order_properties
      ? status.order_properties : {};
    if (status.authenticated === true && status.approved === true && !Object.keys(orderProperties).length) {
      orderProperties = { "_Close-Up approval": "approved" };
      if (status.terms_version) orderProperties["_Close-Up terms version"] = status.terms_version;
    }
    controls().forEach((control) => {
      remember(control);
      if (status.approved) approve(control);
      else requireApproval(control);
      reveal(control);
    });
  }

  function applyRemoteStatus(status) {
    if (!status.authenticated && seededApproved) { applyStatus({ approved: true, order_properties: seededOrderProperties }); return; }
    applyStatus(status);
  }
  async function getStatus() {
    if (!statusPromise) {
      statusPromise = (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(settings.statusUrl, {
            credentials: "same-origin",
            cache: "no-store",
            signal: controller.signal,
            headers: { Accept: "application/json" },
          });
          const result = await response.json();
          if (!response.ok && response.status !== 401) throw new Error("Status unavailable");
          return result;
        } finally {
          clearTimeout(timeout);
        }
      })();
    }
    return statusPromise;
  }

  async function addToCart(control) {
    if (control.getAttribute("aria-busy") === "true" || control.classList.contains("processing")) return;
    control.setAttribute("aria-busy", "true");
    control.classList.add("processing");
    try {
      statusPromise = undefined;
      const status = await getStatus();
      if (!status.authenticated && seededApproved) {
        orderProperties = { ...seededOrderProperties };
        applyStatus({ approved: true, order_properties: seededOrderProperties });
      } else {
        applyStatus(status);
        if (status.approved && !Object.keys(orderProperties).length && Object.keys(seededOrderProperties).length) {
          orderProperties = { ...seededOrderProperties };
        }
      }
      if (!status.approved) {
        if (!status.authenticated && seededApproved && Object.keys(seededOrderProperties).length) { orderProperties = { ...seededOrderProperties }; submitVerifiedItem(control); return; }
        window.location.assign(settings.verificationUrl);
        return;
      }
      if (!Object.keys(orderProperties).length) {
        throw new Error("Verification details are unavailable. Please try again.");
      }
      submitVerifiedItem(control);
    } catch (error) {
      let message = control.parentElement.querySelector('[data-closeup-cart-error]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.closeupCartError = '';
        message.setAttribute('role', 'alert');
        control.parentElement.append(message);
      }
      message.textContent = 'Verification details could not be loaded. Please try adding this item again.';
    } finally {
      control.classList.remove("processing");
      control.removeAttribute("aria-busy");
    }
  }

  function submitVerifiedItem(control) {
    control.parentElement.querySelector('[data-closeup-cart-error]')?.remove();
    const productItem = control.closest("[data-product-item]");
    const quickBuyProxy = productItem?.querySelector(
      "[data-closeup-cart-proxy][data-quick-buy]",
    );

    if (quickBuyProxy) {
      if (quickBuyProxy.disabled || quickBuyProxy.classList.contains("processing")) return;
      quickBuyProxy.closeupOrderProperties = { ...orderProperties };
      quickBuyProxy.click();
      return;
    }

    const form = control.closest('form[action*="/cart/add"]');
    const productAtcProxy = form?.querySelector("[data-product-atc]");

    if (productAtcProxy) {
      if (productAtcProxy.classList.contains("processing")) return;
      form.querySelectorAll('[data-closeup-order-property]').forEach((input) => input.remove());
      Object.entries(orderProperties).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        input.dataset.closeupOrderProperty = '';
        form.append(input);
      });
      productAtcProxy.disabled = false;
      productAtcProxy.type = "submit";
      productAtcProxy.click();
      return;
    }

    window.location.assign(
      control.dataset.closeupProductUrl || settings.verificationUrl,
    );
  }

  function bind() {
    controls().forEach((control) => {
      remember(control);
      if (control.dataset.closeupVerificationBound === "true") return;
      control.dataset.closeupVerificationBound = "true";
      control.addEventListener("click", (event) => {
        if (control.dataset.closeupApproved !== "true") return;
        event.preventDefault();
        addToCart(control);
      });
      control.addEventListener("keydown", (event) => {
        if (control.dataset.closeupApproved !== "true") return;
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        addToCart(control);
      });
    });
  }

  bind();
  if (settings.initialApproved === "true") {
    applyStatus({ approved: true, order_properties: seededOrderProperties });
  }
  getStatus()
    .then(applyRemoteStatus)
    .catch(() => applyRemoteStatus({ authenticated: false }));
  new MutationObserver(() => {
    bind();
    getStatus()
      .then(applyRemoteStatus)
      .catch(() => applyRemoteStatus({ authenticated: false }));
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    controls().forEach((control) => {
      conceal(control);
      control.removeAttribute("aria-busy");
      control.classList.remove("processing");
    });
    statusPromise = undefined;
    getStatus()
      .then(applyRemoteStatus)
      .catch(() => applyRemoteStatus({ authenticated: false }));
  });

  try {
    if (sessionStorage.getItem("pmCloseupVerificationResume") === "1") {
      sessionStorage.removeItem("pmCloseupVerificationResume");
      window.location.assign(settings.verificationUrl);
    }
  } catch (error) {}
})();

// Upgrade existing Close-Up snapshots without changing quantities or reasons.
(() => {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  const privateKeys = ['Close-Up approval', 'Close-Up email verification', 'Close-Up SMS verification', 'Close-Up email sign-in recorded at', 'Close-Up phone ending', 'Close-Up SMS verified at', 'Close-Up reason submitted at', 'Close-Up terms version', 'Close-Up terms accepted at'];
  const base = window.Shopify?.routes?.root || '/';
  const migrate = async () => {
    const response = await fetch(`${base}cart.js`, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    let changed = false;
    for (const item of cart.items || []) {
      const properties = {...item.properties};
      let needsUpdate = false;
      for (const key of privateKeys) {
        if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
        properties[`_${key}`] = properties[key];
        delete properties[key];
        needsUpdate = true;
      }
      if (!needsUpdate) continue;
      const update = await fetch(`${base}cart/change.js`, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:item.key, quantity:item.quantity, properties})});
      if (!update.ok) throw new Error('Cart property update failed');
      changed = true;
    }
    if (changed) location.reload();
  };
  migrate().catch(() => console.warn('Close-Up cart details could not be refreshed. Please reload the cart.'));
})();
